<h4 *ngIf="mode === 'new'">Add encumbrance</h4>
<h4 *ngIf="mode === 'edit'">Edit encumbrance details</h4>
<app-dropdown
	label="Type of encumbrance"
	[itemGroups]="[{ items: encumbranceTypesOptions }]"
	(onSelect)="setEncumbranceType($event)"
	[ngModel]="selectedEncumbranceTypeText"
></app-dropdown>
<app-radio-group
	label="Please select one of the following options"
	[items]="encumbranceActionsOptions"
	class="mt-5"
	[(ngModel)]="selectedEncumbranceAction"
></app-radio-group>
<app-radio-group
	class="mt-5"
	label="Existing priority"
	type="compact"
	[items]="priorityOptions"
	[(ngModel)]="priority"
	*ngIf="
		selectedEncumbranceType === encumbranceTypes.MORTGAGE &&
		(selectedEncumbranceAction === encumbranceActions.DISCHARGE ||
			selectedEncumbranceAction === encumbranceActions.REMAIN)
	"
	[@openClose]
></app-radio-group>
<div class="flex justify-between mt-10">
	<app-button (click)="cancel()" size="small" btn="secondary"
		>Cancel</app-button
	>
	<app-button
		(click)="create()"
		size="small"
		[loading]="_createStatus === createStatusTypes.creating"
		>{{ mode === 'new' ? 'Create' : 'Save' }}</app-button
	>
</div>
